import type { IErrorMessage } from "@Components/ErrorMessage";

import * as css from "./Validator.module.css";

export type IValidator = IErrorMessage;

export type IValidatorList = IErrorMessage[];

export const Validator = (props: IValidator) => (
    <div className={css.validatorComponent}>
        <span className={css.errorMessage} dangerouslySetInnerHTML={{ __html: props.message }} />
    </div>
);
